/**
 * Checkout Action Types
 *
 * @package Enterprise\BookingSystem
 */

export const ACTION_TYPES = {
	// Step navigation
	SET_STEP: "SET_STEP",
	NEXT_STEP: "NEXT_STEP",
	PREV_STEP: "PREV_STEP",

	// Form data updates
	UPDATE_BILLING_ADDRESS: "UPDATE_BILLING_ADDRESS",
	UPDATE_SHIPPING_ADDRESS: "UPDATE_SHIPPING_ADDRESS",
	UPDATE_PAYMENT_INFO: "UPDATE_PAYMENT_INFO",
	SET_SHIP_TO_BILLING: "SET_SHIP_TO_BILLING",
	UPDATE_FIELD: "UPDATE_FIELD",

	// Cart data
	SET_CART_ID: "SET_CART_ID",
	SET_CART_ITEMS: "SET_CART_ITEMS",
	SET_TOTALS: "SET_TOTALS",

	// Validation
	SET_ERRORS: "SET_ERRORS",
	CLEAR_ERRORS: "CLEAR_ERRORS",
	SET_ERROR: "SET_ERROR",
	CLEAR_ERROR: "CLEAR_ERROR",

	// Processing state
	SET_PROCESSING: "SET_PROCESSING",
	SET_VALIDATING: "SET_VALIDATING",
	SET_LOADED: "SET_LOADED",

	// Order result
	SET_ORDER_RESULT: "SET_ORDER_RESULT",

	// Stripe payment
	SET_PAYMENT_INTENT: "SET_PAYMENT_INTENT",
	SET_LOADING_PAYMENT_INTENT: "SET_LOADING_PAYMENT_INTENT",
	CLEAR_PAYMENT_INTENT: "CLEAR_PAYMENT_INTENT",

	// Hydration
	HYDRATE: "HYDRATE",
	PERSIST: "PERSIST",
	CLEAR_STATE: "CLEAR_STATE",

	// Event details
	SET_EVENT_DETAILS: "SET_EVENT_DETAILS",
} as const;

export type ActionType = (typeof ACTION_TYPES)[keyof typeof ACTION_TYPES];
